/**
 * @generated SignedSource<<6722bd6210cc2507a050fea8ddab45f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeactivatedQuoteExplanation_shipmentQuote$data = {
  readonly serviceMethod: {
    readonly region: {
      readonly regionBoundary: {
        readonly locations: ReadonlyArray<{
          readonly country: string | null;
          readonly state: string | null;
          readonly zipCode: string | null;
        } | null> | null;
      } | null;
    } | null;
    readonly serviceMethodType: string | null;
  } | null;
  readonly " $fragmentType": "DeactivatedQuoteExplanation_shipmentQuote";
};
export type DeactivatedQuoteExplanation_shipmentQuote$key = {
  readonly " $data"?: DeactivatedQuoteExplanation_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeactivatedQuoteExplanation_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeactivatedQuoteExplanation_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceMethodType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RegionBoundary",
              "kind": "LinkedField",
              "name": "regionBoundary",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RegionLocation",
                  "kind": "LinkedField",
                  "name": "locations",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "state",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "zipCode",
                      "storageKey": null
                    },
                    {
                      "alias": "country",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayCountry",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "51e892b131f9f03befeb8827b72ce153";

export default node;
